import * as React from 'react';
import styles from './Thanks.css';
import { Title } from '../../title';

export const Thanks = () => {
  return (
    <div className={styles.thanks}>
      <Title Tag='h1'>
        Gefeliciteerd!
      </Title>
      <img src="https://assets.dumpert.nl/onvoldoende.gif" className={styles.image}/> 
      <p>
        Dit was een test. Jij hebt geholpen waarvoor dank &amp; kudo's. 
        Binnenkort komt het echt! (PS : Hou het even stil 😉). 
        <br/><br/>
        Voor bonuspunten: vul hieronder nog even het vragenlijstje in.
      </p>
      <iframe 
        className={styles.survey} 
        src="https://survey.alchemer.eu/s3/90307109/Dumpert-Deluxe-painted-door-survey" 
      /> 
    </div>
  );
};